import * as RadixTooltip from '@radix-ui/react-tooltip';
import type { ReactElement, ReactNode } from 'react';

export const TooltipProvider = ({ children }: { children: ReactNode }) => (
  <RadixTooltip.Provider delayDuration={300} skipDelayDuration={200}>
    {children}
  </RadixTooltip.Provider>
);

export interface TooltipProps {
  content: ReactNode;
  side?: 'top' | 'bottom' | 'left' | 'right';
  delay?: number;
  /** A single focusable element (button, link, icon button) */
  children: ReactElement;
}

/** Hover/focus tooltip. The child must accept a ref (native element or forwardRef component). */
export function Tooltip({ content, side = 'top', delay, children }: TooltipProps) {
  if (content === null || content === undefined || content === '') return children;
  return (
    <RadixTooltip.Root delayDuration={delay}>
      <RadixTooltip.Trigger asChild>{children}</RadixTooltip.Trigger>
      <RadixTooltip.Portal>
        <RadixTooltip.Content
          side={side}
          sideOffset={6}
          collisionPadding={8}
          className="z-[90] max-w-xs rounded-md bg-gray-900 px-2.5 py-1.5 text-xs text-white shadow-lg dark:bg-gray-700"
        >
          {content}
          <RadixTooltip.Arrow className="fill-gray-900 dark:fill-gray-700" />
        </RadixTooltip.Content>
      </RadixTooltip.Portal>
    </RadixTooltip.Root>
  );
}
